<template>
  <b-input
    @input="searchChanged"
    v-model="searchText"
    type="search"
    icon="search"
    :placeholder="placeholder"
  />
</template>
<script>
import _ from "lodash";

export default {
  name: "DelayedInput",
  props: ["placeholder", "delay"],
  data() {
    return {
      searchText: null,
    };
  },
  methods: {
    searchChanged: _.debounce(function() {
      this.$emit("input", this.searchText);
    }, 500),
  },
};
</script>
<style scoped>
@media only screen and (max-width: 600px) {
}
</style>
